var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M16.5 5.333C10.609 5.333 5.833 10.11 5.833 16S10.61 26.667 16.5 26.667 27.167 21.89 27.167 16 22.39 5.333 16.5 5.333M3.167 16c0-7.364 5.97-13.333 13.333-13.333S29.833 8.637 29.833 16 23.863 29.333 16.5 29.333 3.167 23.363 3.167 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M16.5 18.667a1.333 1.333 0 0 1-1.333-1.334V16a1.333 1.333 0 1 1 2.666 0v1.333c0 .737-.597 1.334-1.333 1.334M14.5 22a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M17.02 10.415c-1.276-.06-2.346.652-2.538 1.804a1.333 1.333 0 0 1-2.63-.438c.474-2.848 3.07-4.135 5.295-4.03 1.139.055 2.31.464 3.211 1.306.924.863 1.475 2.1 1.475 3.61 0 1.721-.677 2.998-1.843 3.776-1.071.714-2.384.89-3.49.89a1.333 1.333 0 1 1 0-2.666c.894 0 1.581-.157 2.01-.443.334-.223.657-.612.657-1.557 0-.824-.283-1.337-.63-1.662-.369-.345-.906-.56-1.517-.59"
  })));
};
export default SvgHelp;